//
import Cliente from '../../shared/entity/Cliente';
import Endereco from '../../shared/entity/Endereco';
import { calcularTotalPedido, formatarDinheiro } from '../../shared/helper';
import React, { useEffect, useState } from 'react';
import { Alert, Dimensions, StyleSheet, Text, View } from 'react-native';
import { RadioButton } from 'react-native-paper';
import clienteApi from '../../apis/clienteApi';
import enderecoApi from '../../apis/enderecoApi';
import colors from '../../colors';
import { TXT_M } from '../../constants';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import { useDadosPedido, usePedido } from '../../redux/pedido/pedidoHooks';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import AlertDialog from '../Generic/AlertDialog';
import Divider from '../Generic/Divider';
import HorizontalScroll from '../Generic/HorizontalScroll';
import Title from '../Generic/Title';
import Touchable from '../Generic/Touchable';
import ItemAdicionarEndereco from './ItemAdicionarEndereco';
import ItemEndereco from './ItemEndereco';

const DEVICE_WIDTH = Dimensions.get('window').width;

type Props = {
  temEntrega: boolean;
  setTemEntrega: (x: boolean) => void;
  clienteId: number;
};

const ScrollEnderecos: React.FC<Props> = (props) => {
  const { temEntrega, setTemEntrega, clienteId } = props;

  const [enderecos, setEnderecos] = useState<Endereco[]>([]);
  const [sessao, login, logout, revalidate] = useSessao();
  const [empresa] = useEmpresa();
  const [setEnderecoPedido] = useDadosPedido();
  const [pedido, setPedido] = usePedido();
  const [total, setTotal] = useState(0);

  const [enderecoIdDeletar, setEnderecoIdDeletar] = useState<null | number>(null);

  const getEnderecos = async () => {
    try {
      if(!clienteId){
        return;
      }
      const novos = await enderecoApi.getMany({ where: { clienteId, inativo: false } });
      setEnderecos(novos);
    } catch (err) {
      console.log('err', err);
      Alert.alert('Erro', 'Não foi possível buscar os endereços.');
    }
  };

  useEffect(() => {
    setTotal(calcularTotalPedido(pedido, 0));
  }, [pedido]);

  useEffect(() => {
    getEnderecos();
  }, [clienteId]);

  if (!clienteId || !sessao.cliente || !sessao.token) {
    return null;
  }

  const deletarEndereco = async () => {
    try {
      await clienteApi.deletarEndereco(enderecoIdDeletar, clienteId);
      getEnderecos();
    } catch (err) {
      console.log(err.data);
      Alert.alert('Erro', 'Ocorreu um erro ao deletar esse endereço.');
    }
  };

  return (
    <View>
      <AlertDialog
        titulo={'Deletar Endereço'}
        descricao={'Tem certeza que deseja deletar o endereço?\nEssa ação não pode ser desfeita.'}
        show={Boolean(enderecoIdDeletar)}
        onClose={() => setEnderecoIdDeletar(null)}
        actions={[
          {
            titulo: 'Não',
            onPress: () => setEnderecoIdDeletar(null)
          },
          {
            titulo: 'Sim',
            onPress: () => deletarEndereco(),
            color: colors.red,
            dark: true
          }
        ]}
      />

      <Title style={{ marginBottom: 20 }}>Entrega:</Title>

      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          marginBottom: 20
        }}
      >
        <Touchable
          onPress={() => setTemEntrega(true)}
          style={{ flexDirection: 'row', alignItems: 'center' }}
        >
          <RadioButton
            value="sim"
            status={temEntrega === true ? 'checked' : 'unchecked'}
            onPress={() => setTemEntrega(true)}
          />
          <Text style={styles.radioLabel}>Delivery</Text>
        </Touchable>
        <Touchable
          onPress={() => {
            setTemEntrega(false);
            setEnderecoPedido(null);
          }}
          style={{ flexDirection: 'row', alignItems: 'center' }}
        >
          <RadioButton
            value="não"
            status={temEntrega === false ? 'checked' : 'unchecked'}
            onPress={() => {
              setTemEntrega(false);
              setEnderecoPedido(null);
            }}
          />
          <Text style={styles.radioLabel}>Balcão</Text>
        </Touchable>
      </View>

      {temEntrega === true && (
        <HorizontalScroll>
          {Boolean(enderecos) &&
            enderecos.map((endereco) => (
              <ItemEndereco
                endereco={endereco}
                key={endereco.id}
                onDelete={(end) => {
                  console.log('end', end);

                  setEnderecoIdDeletar(end.id);
                }}
              />
            ))}
          <ItemAdicionarEndereco refresh={() => getEnderecos()} />
        </HorizontalScroll>
      )}

      {temEntrega === true && (
        <View style={styles.viewTaxa}>
          <Text style={styles.labelTaxa}>ENTREGA:</Text>
          {Boolean(
            empresa.valorMinimoDeliveryGratis && total >= empresa.valorMinimoDeliveryGratis
          ) ? (
            <Text style={styles.valorTaxa}>GRÁTIS!</Text>
          ) : (
            <Text style={styles.valorTaxa}>R${formatarDinheiro(empresa.precoDelivery)}</Text>
          )}
        </View>
      )}

      {Boolean(
        temEntrega && empresa.valorMinimoDeliveryGratis && total < empresa.valorMinimoDeliveryGratis
      ) && (
        <View style={styles.viewTaxa}>
          <Text style={styles.valorTaxa}>
            FALTAM R${formatarDinheiro(empresa.valorMinimoDeliveryGratis - total)} PARA A ENTREGA
            GRÁTIS
          </Text>
        </View>
      )}

      <Divider style={{ marginBottom: 10, marginTop: 15 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  radioLabel: {
    fontSize: TXT_M,
    color: colors.darkGrey
  },
  viewTaxa: {
    flexDirection: 'row',
    alignSelf: 'center',
    marginTop: 10,
    justifyContent: 'center',
    alignItems: 'center'
  },
  labelTaxa: { marginRight: 5, fontSize: TXT_M, color: colors.primary },
  valorTaxa: { fontSize: TXT_M, color: colors.values }
});

export default ScrollEnderecos;
